import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import _ from 'lodash'

export default class extends BaseComponent {

  render () {
    let special = this.props.data.special.map((item, i) => {
      return (
        <li key={ i } className="product-item">
          <NavLink to={ "/promocja/" + item.slug }>{ item.title }</NavLink>
        </li>
      )
    })

    let filteredCategories = _.filter(this.props.data.categories, { parent: "0" })

    let categories = filteredCategories.map((item, i) => {
      let products = _.filter(this.props.data.products, { category: item.id }).map((prod, j) => {
      return (
          <li key={ j } className="product-item">
            <NavLink to={ "/produkt/" + prod.slug }>{ prod.title }</NavLink>
          </li>
        )
      })

      return (
        <div key={ i } className="min-nav">
          <h4><NavLink to={ "/oferta/" + item.slug }>{ item.title }</NavLink></h4>
          <ul>
            { products }
          </ul>
        </div>
      )
    })

    return (
      <div className="side-nav">
        { categories }
        <div className="min-nav">
          <h4><NavLink to="/promocje">Promocje</NavLink></h4>
          <ul>
            { special }
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/SideNav.js